








































import AccountingSystem from "@/data/AccountingSystem";
import { remote, webviewTag } from "electron";
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
	...mapGetters(["account", "accountBook"]),
})
export default class NavMiddle extends Vue {
	isJzs = process.env.VUE_APP_TITLE === "jzs";
	multi: App.Link[] = [
		{
			url: "/generalledger",
			name: "总账",
		},
		{
			url: "/subsidiaryledger",
			name: "明细账",
		},
		{
			url: "/multiSubsidiary",
			name: "多栏账",
		},
		{
			url: "/balance",
			name: "余额表",
		},
		{
			url: "/assistingsubsidiaryledger",
			name: "辅助明细账",
		},
		{
			url: "/assistingbalance",
			name: "辅助余额表",
		},
		{
			url: "/vouchergeneral",
			name: "凭证汇总表",
		},
	];
	middleMenuList: App.MiddleMenu[] = [
		{
			title: "做账",
			message: [
				{
					url: "/intelligentvoucher",
					name: "票据",
				},
				{
					url: "/voucherlist",
					name: "凭证",
				},
			],
		},
		{
			title: "库存",
			message: [
				{
					url: "/inventoryOrder",
					name: "出入库单据",
				},
				{
					url: "/inventoryAdjusting",
					name: "产成品结转",
				},
				{
					url: "/inventorySubsidiary",
					name: "库存明细表",
				},
				{
					url: "/inventoryBalance",
					name: "库存汇总表",
				},
			],
		},
		{
			title: "查账",
			message: this.multi
		},
		{
			title: "结账",
			message: [
				{
					url: "/adjusting",
					name: "结转",
				},
				{
					url: "/closing",
					name: "结账",
				},
			],
		},
		{
			title: "报表",
			message: [
				{
					url: "/incomestatement",
					name: "利润表",
				},
				{
					url: "/incomeDistribution",
					name: "收益分配表",
				},
				{
					url: "/businessActivity",
					name: "业务活动表",
				},
				{
					url: "/balancesheet",
					name: "资产负债表",
				},
				{
					url: "/cashFlowstatement",
					name: "现金流量表",
				},
				{
					url: "/declaration",
					name: "纳税申报表",
				},
				{
					url: "/gsnb",
					name: "工商年报",
				},
				// {
				// 	url: "/incomeTax",
				// 	name: "所得税报表"
				// },
			],
		},
		{
			title: "设置",
			message: [
				{
					url: "/subject",
					name: "科目期初",
				},
				{
					url: "/assistingaccount",
					name: "辅助核算",
				},
				{
					url: "/fixedasset",
					name: "资产",
				},
			],
		},
	];

	showNav(data: App.Link): boolean {
		if (
			(data.name === "纳税申报表" || data.name === "利润表") &&
			this.$store.state.accountBook.accountingSystem ===
			AccountingSystem.npo
		) {
			return false;
		} else if (
			data.name === "业务活动表" &&
			this.$store.state.accountBook.accountingSystem !=
			AccountingSystem.npo
		)
			return false;

		// 村集体制度判断
		if (
			(data.name === "纳税申报表" ||
				data.name === "利润表" ||
				data.name === "票据" ||
				data.name === "现金流量表" ||
				data.name === "多栏账") &&
			this.$store.state.accountBook.accountingSystem ===
			AccountingSystem.rural
		) {
			return false;
		} else if (
			data.name === "收益分配表" &&
			this.$store.state.accountBook.accountingSystem !=
			AccountingSystem.rural
		)
			return false;
		return true;
	}

	showTitle(menu: App.MiddleMenu) {
		if (
			menu.title === "库存" &&
			(this.$store.state.accountBook.accountingSystem === AccountingSystem.npo ||
				this.$store.state.accountBook.accountingSystem === AccountingSystem.rural || this.$store.state.accountBook.accountBookInfo.isInventory === 0 || this.$store.state.accountBook.accountBookInfo.isInventory === null)
		) return false;
		return true;
	}

	@Prop({ type: Boolean, default: false })
	isSmallScreen!: boolean;

	clearForward(nav: { url: string; name: string }) {
		this.$store.dispatch("currentPosChange", 0);
		// this.$store.state.tabs[0] = nav;
		this.$set(this.$store.state.tabs, 0, nav);
		this.$store.state.currentTab = 0;
	}
}
